import React, { useState, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { BsArrowLeftCircleFill } from 'react-icons/bs';

const customStyles = {
    content: {
        position: 'absolute',
        width: '50%',
        top: '25%',
        bottom: '10%',
        left: '20%',
        right: '10%',
        height: '30%',
        overflowY: 'none',
        border: '2px solid #ccc',
        background: '#f0f0f0'
    }
};

const PageNavigation = (props) => {
    const { id } = props.match.params;
const { path, category, parentId } = props;

    return (
        <Fragment>
            <div className="card-header border-0 mb-2" style={{backgroundColor:"#DEDEDE"}}>
                <div className="d-flex align-items-center">
                    <Link
                        to={{
                            pathname: `${props.path}`,
                            state: {
                                id: category,
                                parentId: parentId
                            }
                        }}
                    >
                        <BsArrowLeftCircleFill
                            style={{ fontSize: "24px", color: "#8284e5" }}
                        />
                    </Link>
                    <div className="flex-grow-1 text-center">
                        <h5 className="card-title primary my-1">
                            <strong>{props.header}</strong>
                        </h5>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default PageNavigation;
